/* eslint-disable max-len */
/* eslint-disable no-console, react/prop-types */
import {InfoCircleOutlined} from '@ant-design/icons';
import {Flex, Tooltip} from 'antd';
import React from 'react';

import OverviewBarChart from '../../../../../components/Chart/BarChart/OverviewBarChart';
import PilComp from '../../../../../components/DisplayComponent/PilComp';

import {formatBenchmarkValue} from './utils';

const PILL_ABOVE_COLOR = '#EB606A';
const PILL_BELOW_COLOR = '#2D3D25';
const PILL_EQUAL_COLOR = '#F3F4F8';
const BENCHMARK_BAR_COLOR = '#023A5B';
const COMPANY_ABOVE_COLOR = '#F48088';
const COMPANY_BELOW_COLOR = '#91C577';

const BenchmarkCard: React.FC<{item: any}> = ({item}) => {
  const isAbove = item.value > item.benchmark;
  const isBelow = item.value < item.benchmark;
  const isEqual = !isAbove && !isBelow;

  const pillColor = isAbove
    ? PILL_ABOVE_COLOR
    : isBelow
      ? PILL_BELOW_COLOR
      : PILL_EQUAL_COLOR;
  const companyBarColor = isAbove ? COMPANY_ABOVE_COLOR : COMPANY_BELOW_COLOR;

  const cardStatusClass = isAbove
    ? 'industryBenchmarkCard--above'
    : isBelow
      ? 'industryBenchmarkCard--below'
      : 'industryBenchmarkCard--equal';

  const chartData = [
    {
      source: 'Benchmark',
      value: item.benchmark,
      unit: item.unit,
      fill: BENCHMARK_BAR_COLOR
    },
    {
      source: 'Company',
      value: item.value,
      unit: item.unit,
      fill: companyBarColor
    }
  ];

  return (
    <div className={`industryBenchmarkCard ${cardStatusClass}`}>
      <Flex
        className="industryBenchmarkCardHeader"
        justify="space-between"
        align="center"
        gap={8}
      >
        <PilComp
          value={item.label}
          color={pillColor}
          style={{
            padding: '6px 12px',
            color: isEqual ? '#374151' : '#fff',
            font: 'normal normal 700 12px Montserrat'
          }}
        />
        <Tooltip title={item.tooltip}>
          <InfoCircleOutlined className="industryBenchmarkCardInfo" />
        </Tooltip>
      </Flex>
      <Flex className="industryBenchmarkCardLegend" gap={12}>
        <Flex align="center" gap={6}>
          <span
            className="industryBenchmarkLegendDot"
            style={{background: BENCHMARK_BAR_COLOR}}
          />
          <span className="industryBenchmarkLegendText">Benchmark Value</span>
        </Flex>
        <Flex align="center" gap={6}>
          <span
            className="industryBenchmarkLegendDot"
            style={{background: companyBarColor}}
          />
          <span className="industryBenchmarkLegendText">Company Value</span>
        </Flex>
      </Flex>
      <div className="industryBenchmarkChartWrap">
        <div className="industryBenchmarkChartInner" style={{height: 140}}>
          <OverviewBarChart data={chartData} />
        </div>
      </div>
      <div className="industryBenchmarkDataArea">
        <div className="industryBenchmarkCompanyRow">
          <span className="industryBenchmarkValueBold">
            {formatBenchmarkValue(item.value, item.unit)}
          </span>
          <span className="industryBenchmarkValueLabel">Company</span>
        </div>
        <div className="industryBenchmarkDottedLine" />
        <div className="industryBenchmarkBenchmarkRow">
          <span className="industryBenchmarkValueBold industryBenchmarkValueSmall">
            {formatBenchmarkValue(item.benchmark, item.unit)}
          </span>
          <span className="industryBenchmarkValueLabel">Benchmark</span>
        </div>
      </div>
    </div>
  );
};

export default BenchmarkCard;
